<template>
    <vPerformanceAssignmentLineComponent :postList="postList" v-if="flag"></vPerformanceAssignmentLineComponent>
</template>
<script>
import vPerformanceAssignmentLineComponent from '../../listComponent/basicdata/performance/performanceAssignmentLineComponent.vue';
export default {
    name: 'performance_assignment_line',
    components: {
        vPerformanceAssignmentLineComponent
    },
    data() {
        return {
            postList: {
                headerTitle: true,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.initParams();
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {
        initParams() {
            this.postList.params = {
                performance_assignment_rid: this.$route.query.id,
                type: 'insert'
            };
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>